<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70" />
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-row>
          <b-col md="4" class="my-1">
            <b-navbar-nav>
              <b-button @click="goBack" size="sm" class="ml-2 mr-2" variant="outline-secondary" style="font-size: 0.675rem">
                <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
              </b-button>
            </b-navbar-nav>
            <h5 class="mt-1 mr-2">{{ $route.name }}</h5>
          </b-col>
          <b-col md="2">
            <h5>
              <small v-if="!isLoading">{{ totalData }} Entries</small>
            </h5>
          </b-col>
          <b-col md="6">
            <b-button
              class="pull-right ml-1 mt-1"
              v-if="records.length > 0"
              :disabled="ExcelBtnName !== 'Export As Excel'"
              @click="exportExcel"
              size="sm"
              variant="warning"
              style="font-size: 0.675rem"
            >
              {{ ExcelBtnName }}
              <b-spinner v-if="ExcelBtnName !== 'Export As Excel'" small label="Small Spinner"></b-spinner>
            </b-button>
          </b-col>
          <b-col cols="12">
            <div>
              <b-pagination
                limit="25"
                align="center"
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total-rows="totalData"
                @change="onPageChange($event)"
              />
            </div>
          </b-col>
        </b-row>

        <div class="row">
          <div class="col-md-12">
            <div class="table-responsive tableMain gutr">
              <b-table
                show-empty
                stacked="md"
                responsive
                :items="records"
                :fields="fields"
                :per-page="pagination.perPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
                class="position-relative"
              >
                <template slot="SN" slot-scope="row0">
                  <span>{{ row0.index + 1 + (pagination.currentPage - 1) * pagination.perPage }}</span>
                </template>
                <template slot="profit" slot-scope="row1">
                  <span :class="Number(row1.item.profit) >= 0 ? 'text-success' : 'text-danger'">
                    {{ formatCurrency(row1.item.profit) }}
                  </span>
                </template>
                <template slot="expenses" slot-scope="row2">
                  {{ formatCurrency(row2.item.expenses) }}
                </template>
                <template slot="incomes" slot-scope="row3">
                  {{ formatCurrency(row3.item.incomes) }}
                </template>
              </b-table>
            </div>
            <div>
              <b-pagination
                limit="25"
                align="center"
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total-rows="totalData"
                @change="onPageChange($event)"
              />
            </div>
          </div>
        </div>
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
import CustomLoader from "../common/customLoader.vue";
import NodeLockPannelService from "../../services/NodeLockPannelService";
import * as XLSX from "xlsx";

export default {
  data() {
    return {
      isLoading: false,
      ExcelBtnName: "Export As Excel",
      records: [],
      totalData: 0,
      // query params expected by backend
      search: '',
      sortKey: 'pl_job_no',
      sortDescStr: 'false',
      from_date: '',
      to_date: '',
      job_no: '',
      billing_party: '',
      is_all: 0,
      isSelectedColumn: 0,
      pagination: {
        currentPage: 1,
        perPage: 10,
        totalPages: 0,
      },
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      fields: [
        { key: 'SN', label: 'SN.', sortable: false },
        { key: 'jobNo', label: 'Job No', sortable: true },
        { key: 'jobType', label: 'Job Type', sortable: true },
        { key: 'jobDate', label: 'Job Date', sortable: true },
        { key: 'period', label: 'Period', sortable: true },
        { key: 'fromDate', label: 'From Date', sortable: true },
        { key: 'toDate', label: 'To Date', sortable: true },
        { key: 'createdAt', label: 'Created At', sortable: true },
        { key: 'clientName', label: 'Client', sortable: true },
        { key: 'exporterName', label: 'Exporter', sortable: true },
        { key: 'importerName', label: 'Importer', sortable: true },
        { key: 'branch', label: 'Branch', sortable: true },
        { key: 'from', label: 'From', sortable: true },
        { key: 'pol', label: 'POL', sortable: true },
        { key: 'pod', label: 'POD', sortable: true },
        { key: 'fpod', label: 'FPOD', sortable: true },
        { key: 'employee', label: 'Employee', sortable: true },
        { key: 'transportType', label: 'Transport Type', sortable: true },
        { key: 'jobType', label: 'Job Type', sortable: true },
        { key: 'containerType', label: 'Container', sortable: true },
        { key: 'expenses', label: 'Expenses', sortable: true },
        { key: 'incomes', label: 'Incomes', sortable: true },
        { key: 'profit', label: 'Profit', sortable: true },
      ],
    };
  },
  components: { CustomLoader },
  created() {
    this.fetch();
  },
  methods: {
    goBack() { window.history.go(-1); },
    formatCurrency(val) {
      const n = Number(val);
      if (Number.isNaN(n)) return val;
      return n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    async fetch() {
      try {
        this.isLoading = true;
        // Map table sort state to API expected params
        this.sortKey = this.sortBy || this.sortKey || 'pl_job_no';
        this.sortDescStr = this.sortDesc ? 'true' : 'false';
        const payload = {
          page: this.pagination.currentPage,
          pageSize: this.pagination.perPage,
          search: this.search || '',
          sortDesc: this.sortDescStr || 'false',
          sortKey: this.sortKey || 'pl_job_no',
          from_date: this.from_date || undefined,
          to_date: this.to_date || undefined,
          job_no: this.job_no || undefined,
          billing_party: this.billing_party || undefined,
          is_all: this.is_all || 0,
          isSelectedColumn: this.isSelectedColumn || 0,
        };
        const { data } = await NodeLockPannelService.getProfitLoss(payload);
        const list = data && data.data && Array.isArray(data.data.records) ? data.data.records : [];
        const pg = (data && data.data && data.data.pagination) || {};
        this.records = list;
        this.totalData = Number(pg.totalCount || list.length || 0);
        this.pagination.totalPages = Number(pg.totalPages || Math.ceil(this.totalData / this.pagination.perPage) || 0);
        this.pagination.currentPage = Number(pg.currentPage || this.pagination.currentPage);
        this.pagination.perPage = Number(pg.pageSize || this.pagination.perPage);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('Profit & Loss fetch error', e);
        this.records = [];
        this.totalData = 0;
      } finally {
        this.isLoading = false;
      }
    },
    onPageChange(event) {
      this.pagination.currentPage = event;
      this.fetch();
    },
    async exportExcel() {
      this.ExcelBtnName = 'Downloading Please Wait .....';
      try {
        // 1) Fetch all data without pagination
        const payloadAll = {
          page: 1,
          pageSize: 999999, // effectively all
          search: this.search || '',
          sortDesc: this.sortDescStr || 'false',
          sortKey: this.sortKey || 'pl_job_no',
          from_date: this.from_date || undefined,
          to_date: this.to_date || undefined,
          job_no: this.job_no || undefined,
          billing_party: this.billing_party || undefined,
          is_all: 1,
          isSelectedColumn: this.isSelectedColumn || 0,
        };
        const { data } = await NodeLockPannelService.getProfitLoss(payloadAll);
        const allRecords = data && data.data && Array.isArray(data.data.records) ? data.data.records : [];

        // 2) Prepare worksheet data including SN column
        const visibleFields = this.fields.filter(f => f.key !== 'SN');
        const headers = ['SN', ...visibleFields.map(f => f.label)];
        // Fields that should be treated as dates
        const dateFieldKeys = new Set(['jobDate', 'fromDate', 'toDate', 'createdAt']);
        const rows = allRecords.map((rec, idx) => {
          const obj = { SN: idx + 1 };
          visibleFields.forEach(f => {
            let val = rec[f.key];
            if (f.key === 'profit' || f.key === 'expenses' || f.key === 'incomes') {
              const n = Number(val);
              val = Number.isNaN(n) ? val : n;
            } else if (dateFieldKeys.has(f.key)) {
              // Convert to real Date if parsable
              const d = val ? new Date(val) : null;
              if (d && !isNaN(d.getTime())) {
                val = d;
              }
            }
            obj[f.label] = val != null ? val : '';
          });
          return obj;
        });

        const ws = XLSX.utils.json_to_sheet(rows, { header: headers });
        // Apply date number format to date columns
        const dateHeaderLabels = visibleFields
          .filter(f => dateFieldKeys.has(f.key))
          .map(f => f.label);
        const range = XLSX.utils.decode_range(ws['!ref']);
        const headerIndexMap = new Map(headers.map((h, i) => [h, i]));
        const dateCols = dateHeaderLabels
          .map(lbl => headerIndexMap.get(lbl))
          .filter(i => typeof i === 'number');
        for (let r = range.s.r + 1; r <= range.e.r; r++) { // skip header row
          for (const c of dateCols) {
            const cellAddr = XLSX.utils.encode_cell({ c, r });
            const cell = ws[cellAddr];
            if (cell && cell.v instanceof Date) {
              cell.z = 'yyyy-mm-dd';
            }
          }
        }
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'ProfitLoss');
        XLSX.writeFile(wb, `profit-loss-${new Date().toISOString().slice(0,10)}.xlsx`);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('xlsx export error', e);
      } finally {
        this.ExcelBtnName = 'Export As Excel';
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// profitLoss.vue?51956efd